import React from "react"

import TasksView_Column from "../../../../../model2/column/column"
import {
    AggregateFunctionType
} from "../../../../../data-structures/aggregators/types"
import AggregateShellComponent from "../../../../../gd-modules/common/aggregate/aggregate-shell"
import StatusSummaryBar from "../table/calculated/summary"

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldStatus_AggregateCell"
const debug = false

export default function FieldStatus_AggregateCell(props: Props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value)

    // Get available aggregate function options for this field, if any
    const options = props.column.field?.getAggregateOptions()

    debug && console.log(debug, 'render', props.value)

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            {isValid &&
                <div className="aggregate-value flex-row-left-center w-100p">
                    <StatusSummaryBar data={props.value}/>
                </div>}
        </AggregateShellComponent>
    )
}
